// 発行の正規化応答(Issuances + related.Materials/Users/Groups)を、従来のネスト形(issuanceRow)へ
// 復元する共通ハイドレータ。結合は nestHydrator の宣言的エンジン(生成メタデータのエッジキー)で行う。
// User の結び付けは api 側 Sequelize の関連付け(同名 belongsTo の後勝ち)と同じ規則で
// created_by_user_id を使う(材料検索ハイドレータの Issuance→User と同一)。
// Materials の並びはサーバーのバケット順(id 昇順)をそのまま保つ。
import { issuanceRow, NormalizedIssuanceResponse } from "../../schema/console/issuance";
import { hasManyOf, requiredUserOf } from "./nestHydrator";
import { usersWithGroupOf } from "./relatedLookup";

export function hydrateIssuances(normalized: NormalizedIssuanceResponse): issuanceRow[] {
  const users = usersWithGroupOf(normalized.related.Users, normalized.related.Groups);
  const materialsOf = hasManyOf("Issuance.Materials", normalized.related.Materials);
  const issuanceUserOf = requiredUserOf("Issuance.created_by_user_id", users, "発行", "登録者");
  return normalized.Issuances.map((issuance): issuanceRow => ({
    ...issuance,
    Materials: materialsOf(issuance.id),
    User: issuanceUserOf(issuance),
  }));
}
